import Details from '../Details/details';
import * as selectors from '../../../../../home24-shared/components/quickview/constants/selectors';
import Pictures from '../Pictures/pictures-ds-swiper';
import swiperClassNames from './../../../../../home24-shared/components/quickview/constants/classNames-swiper';
import {
  height as getHeight,
  getDataOptions
} from '../../../../../home24-shared/components/quickview/functions/helpers/helpers';

const App = ({ data }) => {
  const height = getHeight(data.selectedMvcAttributes);
  const strDataOptions = JSON.stringify(getDataOptions()).replace(/'/g, "\\'");

  return `
<article class="${
    swiperClassNames.ARTICLE
  } js-quick-view" data-options='${strDataOptions}'>
  <div class="${swiperClassNames.WRAP}" style="height: ${height}px">
  <div id="${selectors.NOTIFICATION}"></div>
  <div id="${selectors.NOTSELLABLE}"></div>
    ${Details({ className: swiperClassNames, data, height })}
    ${Pictures({ className: swiperClassNames, images: data.images, height })}
  </div>
</article>
  `;
};

export default App;



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/components/quickview/components/App/app.js
 **/